<template>
  <b-carousel class="mx-auto custom-carousel" id="carousel1" controls indicators background="#ababab" :interval="4000"
    v-model="slide" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
    <b-carousel-slide :img-src="require('@/assets/kn-Xorio.jpg')"></b-carousel-slide>
    <b-carousel-slide :img-src="require('@/assets/kn-Skiadi.jpg')"></b-carousel-slide>
    <b-carousel-slide :img-src="require('@/assets/kn-Goupa.jpg')"></b-carousel-slide>
  </b-carousel>
</template>

<script>
export default {
  data () {
    return {
      slide: 0,
      sliding: null
    }
  },
  methods: {
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
  },
}
</script>

<style lang="scss">
/* Adjust carousel height */
.custom-carousel {
  height: 50%;
  /* Adjust to 50% of its original height */
  max-height: 300px;
  /* Optional: limit the max height */
  overflow: hidden;
  /* Prevent overflow if images exceed the height */
}

.custom-carousel .carousel-inner {
  height: 100%;
  /* Ensure slides fill the reduced height */
}

.custom-carousel .carousel-item img {
  object-fit: cover;
  /* Ensure images resize proportionally */
  height: 100%;
  /* Match the reduced carousel height */
}
</style>


// WEBPACK FOOTER //
// src/components/carousel.vue